'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlPageBreadcrumb", function () {
  return {
    restrict: "E",
    replace: true,
    require: "^tlMainContainer",
    transclude: true,
    scope: true,
    template: '<div class="tl-page-breadcrumb" ng-transclude></div>',
    link: function link($scope, $el, $attrs, containerCtrl) {
      containerCtrl.setBreadcrumbLayout(true);
      $scope.$on("$destroy", function () {
        containerCtrl.setBreadcrumbLayout(false);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/pageBreacrumb.js
// module id = 3004
// module chunks = 13